import { useEffect, useState } from 'react';
import { searchFilterFoTable } from 'components/Table/lib/searchFilters';

export function useFilteredData<Entity>(paginationProps: any, tableData: Entity[]) {
  const [filteredData, setFilteredData] = useState<Entity[]>([]);

  useEffect(() => {
    setFilteredData(tableData);

    return () => {
      setFilteredData([]);
    };
  }, [tableData]);

  const onFilteredChange = (newFiltering: any[]) => {
    setFilteredData(searchFilterFoTable(tableData, newFiltering));
    paginationProps.onPageChange(0);
  };

  return {
    filteredData,
    onFilteredChange,
  };
}
